import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_8051 = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="8051 Organization and Architecture"
      videos={[
        "https://www.youtube.com/embed/0E4KWXlcSlE", // Pin Diagram of 8051
        "https://www.youtube.com/embed/I_qFGUTBYek", // Block Diagram of 8051
        "https://www.youtube.com/embed/8QQvEitp4VQ", // 16-bit Addition in 8051
        "https://www.youtube.com/embed/n6H7D23Hu4Y", // Important Parts of 8051
      ]}
      takeaways={[
        { text: "Questions may focus on architecture or pin diagram of 8051." },
        { text: "Memorize all bits in the Program Status Word (PSW) register." },
        { text: "Understand how PSW changes after arithmetic operations." },
        { text: "Learn the program for adding two 16-bit numbers in 8051." },
      ]}
      questions={[]} // No specific previous questions provided
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_8051;
